<template>
  <div>
    <div class="goodsManageSet">
      <div class="banner">
        <img src="../../../assets/images/banner3.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">物流&订单管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">审批操作</div>
      </div>

      <div class="main_content">
        <div class="block">
          <h1>退款原因</h1>
          <p>{{ dataItem.reasonidstr }}</p>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>退款审核状态</h1>
          <div class="radio_box">
            <van-radio-group
              v-model="formData.checkstate"
              style="justify-content: space-evenly"
            >
              <van-radio name="1" style="margin-bottom: 15px">审核中</van-radio>
              <van-radio name="2" style="margin-bottom: 15px">审核中（待用户发货收到的商品）</van-radio>
              <van-radio name="3" style="margin-bottom: 15px">审核中（已收到退货）</van-radio>
              <van-radio name="4">同意退款</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import { getBacklogDetail, editBacklogState } from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cBacklogEdit",
  data() {
    return {
      isShowType: 1,
      id: "",
      dataItem: "",
      formData: {
        checkstate: "",
        orderid: "",
        openid: "",
        id: "",
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
         let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getBacklogDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 仓库配货列表
    getBacklogDetail(id) {
      getBacklogDetail({ id }).then((res) => {
        this.dataItem = res;
        this.formData.id = res.id;
        this.formData.openid = res.openid;
        this.formData.orderid = res.orderid;
        this.formData.checkstate = res.checkstate;
      });
    },

    // 保存
    query() {
      let { formData } = this;
      if (formData.checkstate == "") {
        this.$toast("请选择退款审核状态");
        return;
      }
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editBacklogState(this.formData).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .item {
        margin-bottom: 50px;
      }
      .input_box,
      .select_box {
        margin-bottom: 30px;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
      .warehouse {
        width: 560px;
        margin: auto;
        text-align: left;
      }
    }
  }
}
</style>